import { useTranslation } from 'react-i18next';

import EarthIcon from '@/assets/icons/earth.svg';
import { Select } from '@/components/form/select';
import { availableLanguages } from '@/locales/i18n';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  return (
    <Select
      options={[
        ...availableLanguages.map((lang) => ({
          label: (
            <div className="flex gap-1">
              <img src={EarthIcon} alt="translation icon" />
              <span className="ml-1 font-bold">{lang}</span>
            </div>
          ),
          value: lang,
        })),
      ]}
      onChange={(e) => i18n.changeLanguage(e)}
      menuItemClassnames="w-20"
      defaultValue={i18n.language}
      variant="plain"
      chevron={false}
    />
  );
};
